var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_4463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.26351 530.602H853.393V652.779L780.204 604.404L673.86 649.677L566.263 604.403L473.057 690.61L372.341 719.14L327.928 682.548L292.896 629.831L259.742 661.462L185.926 600.062L134.63 607.505L77.0795 558.509L2.63916 539.904L3.26351 530.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 530.602V531.203H852.787V651.655L780.267 603.722L673.859 649.023L566.139 603.697L472.75 690.071L372.483 718.474L328.385 682.142L293.001 628.896L259.714 660.653L186.108 599.428L134.816 606.869L77.3663 557.961L3.27796 539.443L3.86903 530.642L3.26384 530.602V531.203V530.602L2.65865 530.562L2 540.364L76.7934 559.058L134.445 608.14L185.745 600.697L259.769 662.27L292.792 630.767L327.47 682.953L372.201 719.805L473.364 691.148L566.39 605.109L673.861 650.331L780.141 605.085L854 653.903V530H2.69597L2.65865 530.562L3.26384 530.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 530.602V531.203H852.787V651.655L780.267 603.722L673.859 649.023L566.139 603.697L472.75 690.071L372.483 718.474L328.385 682.142L293.001 628.896L259.714 660.653L186.108 599.428L134.816 606.869L77.3663 557.961L3.27796 539.443L3.86903 530.642L3.26384 530.602ZM3.26384 530.602V531.203V530.602ZM3.26384 530.602L2.65865 530.562L2 540.364L76.7934 559.058L134.445 608.14L185.745 600.697L259.769 662.27L292.792 630.767L327.47 682.953L372.201 719.805L473.364 691.148L566.39 605.109L673.861 650.331L780.141 605.085L854 653.903V530H2.69597L2.65865 530.562L3.26384 530.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19 375.29C416.63 394.29 416.75 401.08 422.19 422.42",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.97 375.29C450.53 394.29 450.4 401.08 444.97 422.42",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.32 303.68C458.27 361.29 568.3 358.29 574.19 446.29",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.19 304.29H423V505.29H445.19V304.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 440.29H429V504.29H437.19V440.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.19 438.29H417V508.29H429.19V438.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19 495.29H413V505.29H417.19V495.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19 477.29H413V487.29H417.19V477.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19 457.29H413V467.29H417.19V457.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19 441.29H413V451.29H417.19V441.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.19 420.29H420V438.29H427.19V420.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.19 348.29H394V374.29H397.19V348.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23 359.29H398V363.29H402.23V359.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.19 438.29H437V508.29H449.19V438.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19 495.29H449V505.29H453.19V495.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19 477.29H449V487.29H453.19V477.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19 457.29H449V467.29H453.19V457.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19 441.29H449V451.29H453.19V441.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 443.29H429V448.29H437.19V443.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 460.29H429V465.29H437.19V460.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 479.29H429V484.29H437.19V479.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19 497.29H429V502.29H437.19V497.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.19 420.29H440V438.29H447.19V420.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.19 446.29H570V469.29H579.19V446.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.19 462.29H586V469.29H595.19V462.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.19 462.29H602V469.29H611.19V462.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.92 461.29H673.19V489.29H670.92C669.881 489.287 668.886 488.874 668.151 488.139C667.416 487.404 667.003 486.409 667 485.37V465.21C667.003 464.171 667.416 463.176 668.151 462.441C668.886 461.707 669.881 461.293 670.92 461.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.19 465.29H663V469.29H666.19V465.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.19 482.29H663V486.29H666.19V482.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.19 472.29H662.19V479.29H666.19V472.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.46 461.29H673.19V489.29H675.46C676.499 489.287 677.494 488.874 678.229 488.139C678.963 487.404 679.377 486.409 679.38 485.37V465.21C679.377 464.171 678.963 463.176 678.229 462.441C677.494 461.707 676.499 461.293 675.46 461.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.38 465.29H680.19V469.29H683.38V465.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.38 482.29H680.19V486.29H683.38V482.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.19 472.29H680.19V479.29H684.19V472.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.19 466.29H94V483.99H760.19V466.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92 461.29H179.19V489.29H176.92C175.881 489.287 174.886 488.874 174.151 488.139C173.416 487.404 173.003 486.409 173 485.37V465.21C173.003 464.171 173.416 463.176 174.151 462.441C174.886 461.707 175.881 461.293 176.92 461.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.19 465.29H169V469.29H172.19V465.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.19 482.29H169V486.29H172.19V482.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.19 472.29H168.19V479.29H172.19V472.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46 461.29H179.19V489.29H181.46C182.499 489.287 183.494 488.874 184.229 488.139C184.963 487.404 185.377 486.409 185.38 485.37V465.21C185.377 464.171 184.963 463.176 184.229 462.441C183.494 461.707 182.499 461.293 181.46 461.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38 465.29H186.19V469.29H189.38V465.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38 482.29H186.19V486.29H189.38V482.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19 472.29H186.19V479.29H190.19V472.29Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2 357.41H402.28V365.72H410.2V357.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2 341.41H411.28V346.29H456.2V341.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2 346.41H411.28V349.29H456.2V346.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2 370.41H411.28V375.29H456.2V370.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2 375.41H411.28V378.29H456.2V375.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2 349.41H411.28V370.29H456.2V349.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.49 348.41H469.3V374.41H472.49V348.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.49 359.41H464.26V363.41H468.49V359.41Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.22 357.53H456.3V365.84H464.22V357.53Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.53 363.01L423.11 355.26",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.82 359.85C422.212 359.85 422.53 359.532 422.53 359.14C422.53 358.748 422.212 358.43 421.82 358.43C421.428 358.43 421.11 358.748 421.11 359.14C421.11 359.532 421.428 359.85 421.82 359.85Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75 360.46L436.9 359.81",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.82 360.85C433.212 360.85 433.53 360.532 433.53 360.14C433.53 359.748 433.212 359.43 432.82 359.43C432.428 359.43 432.11 359.748 432.11 360.14C432.11 360.532 432.428 360.85 432.82 360.85Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.8 356.38L448.8 361.89",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.82 359.85C446.212 359.85 446.53 359.532 446.53 359.14C446.53 358.748 446.212 358.43 445.82 358.43C445.428 358.43 445.11 358.748 445.11 359.14C445.11 359.532 445.428 359.85 445.82 359.85Z",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.69 193.79H391.69C389.481 193.79 387.69 195.581 387.69 197.79V300.79C387.69 302.999 389.481 304.79 391.69 304.79H475.69C477.899 304.79 479.69 302.999 479.69 300.79V197.79C479.69 195.581 477.899 193.79 475.69 193.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.21 210.79H391.17C390.905 210.79 390.69 211.005 390.69 211.27V284.31C390.69 284.575 390.905 284.79 391.17 284.79H392.21C392.475 284.79 392.69 284.575 392.69 284.31V211.27C392.69 211.005 392.475 210.79 392.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.21 210.79H397.17C396.905 210.79 396.69 211.005 396.69 211.27V284.31C396.69 284.575 396.905 284.79 397.17 284.79H398.21C398.475 284.79 398.69 284.575 398.69 284.31V211.27C398.69 211.005 398.475 210.79 398.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21 210.79H403.17C402.905 210.79 402.69 211.005 402.69 211.27V284.31C402.69 284.575 402.905 284.79 403.17 284.79H404.21C404.475 284.79 404.69 284.575 404.69 284.31V211.27C404.69 211.005 404.475 210.79 404.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.21 210.79H409.17C408.905 210.79 408.69 211.005 408.69 211.27V284.31C408.69 284.575 408.905 284.79 409.17 284.79H410.21C410.475 284.79 410.69 284.575 410.69 284.31V211.27C410.69 211.005 410.475 210.79 410.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.21 210.79H415.17C414.905 210.79 414.69 211.005 414.69 211.27V284.31C414.69 284.575 414.905 284.79 415.17 284.79H416.21C416.475 284.79 416.69 284.575 416.69 284.31V211.27C416.69 211.005 416.475 210.79 416.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.21 210.79H421.17C420.905 210.79 420.69 211.005 420.69 211.27V284.31C420.69 284.575 420.905 284.79 421.17 284.79H422.21C422.475 284.79 422.69 284.575 422.69 284.31V211.27C422.69 211.005 422.475 210.79 422.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.21 210.79H427.17C426.905 210.79 426.69 211.005 426.69 211.27V284.31C426.69 284.575 426.905 284.79 427.17 284.79H428.21C428.475 284.79 428.69 284.575 428.69 284.31V211.27C428.69 211.005 428.475 210.79 428.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.21 210.79H433.17C432.905 210.79 432.69 211.005 432.69 211.27V284.31C432.69 284.575 432.905 284.79 433.17 284.79H434.21C434.475 284.79 434.69 284.575 434.69 284.31V211.27C434.69 211.005 434.475 210.79 434.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.21 210.79H438.17C437.905 210.79 437.69 211.005 437.69 211.27V284.31C437.69 284.575 437.905 284.79 438.17 284.79H439.21C439.475 284.79 439.69 284.575 439.69 284.31V211.27C439.69 211.005 439.475 210.79 439.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.21 210.79H445.17C444.905 210.79 444.69 211.005 444.69 211.27V284.31C444.69 284.575 444.905 284.79 445.17 284.79H446.21C446.475 284.79 446.69 284.575 446.69 284.31V211.27C446.69 211.005 446.475 210.79 446.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.21 210.79H450.17C449.905 210.79 449.69 211.005 449.69 211.27V284.31C449.69 284.575 449.905 284.79 450.17 284.79H451.21C451.475 284.79 451.69 284.575 451.69 284.31V211.27C451.69 211.005 451.475 210.79 451.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.21 210.79H456.17C455.905 210.79 455.69 211.005 455.69 211.27V284.31C455.69 284.575 455.905 284.79 456.17 284.79H457.21C457.475 284.79 457.69 284.575 457.69 284.31V211.27C457.69 211.005 457.475 210.79 457.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.21 210.79H462.17C461.905 210.79 461.69 211.005 461.69 211.27V284.31C461.69 284.575 461.905 284.79 462.17 284.79H463.21C463.475 284.79 463.69 284.575 463.69 284.31V211.27C463.69 211.005 463.475 210.79 463.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.21 210.79H468.17C467.905 210.79 467.69 211.005 467.69 211.27V284.31C467.69 284.575 467.905 284.79 468.17 284.79H469.21C469.475 284.79 469.69 284.575 469.69 284.31V211.27C469.69 211.005 469.475 210.79 469.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.21 210.79H474.17C473.905 210.79 473.69 211.005 473.69 211.27V284.31C473.69 284.575 473.905 284.79 474.17 284.79H475.21C475.475 284.79 475.69 284.575 475.69 284.31V211.27C475.69 211.005 475.475 210.79 475.21 210.79Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.37 218.16H417.01C416.552 218.16 416.18 218.532 416.18 218.99V228.97C416.18 229.429 416.552 229.8 417.01 229.8H453.37C453.829 229.8 454.2 229.429 454.2 228.97V218.99C454.2 218.532 453.829 218.16 453.37 218.16Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.8 197.16H422.58C422.083 197.16 421.68 197.563 421.68 198.06V205.9C421.68 206.397 422.083 206.8 422.58 206.8H474.8C475.297 206.8 475.7 206.397 475.7 205.9V198.06C475.7 197.563 475.297 197.16 474.8 197.16Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.77 121V163",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.77 142V193.29",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27 125V159",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.67 129V155",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.19 133V151",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.19 134V150",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.19 142H431.77",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_4463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfm);
export default __webpack_public_path__ + "static/media/efm.605e18d88e2e661e6e5e9db007d25634.svg";
export { ForwardRef as ReactComponent };